<div
  class="postal-code-map-selector tw-border dark:tw-border-dark-100 md:tw-flex-row tw-flex-col"
>
  <!-- the side panel area -->
  <div
    #sidePanel
    class="side-panel tw-bg-white dark:tw-bg-dark-200 md:tw-w-1/3 tw-w-full tw-py-4 tw-pr-2"
  >
    <!-- #region side panel accordion -->
    <mat-accordion class="side-accordion">
      <!-- #region city panel -->
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="expansion-panel-header">
          <mat-panel-title>
            {{'pages.sendSmsFromMap.fields.selectCity' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <zones-select-search
          #selStates
          class="tw-w-full"
          label="common.state"
          type="forMap"
          [bulkDatabaseVersion]="bulkDatabaseVersion"
          [control]="cityForm?.get('stateId')"
          [id]="1"
          [value]="stateId"
          (valueChange)="setStateId($event)"
        >
        </zones-select-search>

        <zones-select-search
          #selCities
          label="common.city"
          class="tw-w-full"
          type="forMap"
          [bulkDatabaseVersion]="bulkDatabaseVersion"
          [id]="stateId"
          [control]="cityForm?.get('cityId')"
          [value]="cityId"
          (valueChange)="setCityId($event)"
        >
        </zones-select-search>
      </mat-expansion-panel>
      <!-- #endregion -->
      <!-- #region postalCode Code's-->
      <!-- start of hamrah aval region settings-->
      <mat-expansion-panel
        #operators
        *ngIf="selectedLayer!=null && (selectedLayerTotalHamrahAval>0||selectedLayerTotalIrancell>0)"
      >
        <mat-expansion-panel-header class="expansion-panel-header">
          <mat-panel-title>
            {{'pages.sendSmsFromMap.fields.regionSettings' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!--postalCode-->
        <div class="tw-mb-6" *ngIf="selectedLayer!=null">
          <list-group-item
            [label]="'common.postalCode'"
            [value]="selectedLayer?.postalCode"
          >
          </list-group-item>
        </div>
        <!----------------------------------- hamrahAvalPanel ----------------------------------->
        <section
          class="operator-section"
          #hamrahAvalPanel
          *ngIf="selectedLayer!=null"
        >
          <fieldset>
            <legend>
              <span> {{'common.sendTo' | translate}}</span>
              <span class="mci-color tw-mr-1">
                {{'common.mci' | translate}}</span
              >
              <img [src]="mciImage" class="tw-mx-1" width="16" />
            </legend>

            <!--MCI total count-->
            <form-field
              class="tw-w-full tw-px-1 tw-ml-[-59px] tw-block"
              [label]="'pages.sendSmsFromMap.fields.total'|translate"
              [value]="selectedLayerTotalHamrahAval|numberSeparator"
              [isReadOnly]="true"
            >
            </form-field>

            <div class="tw-flex flex-wrap">
              <!--MCI start from-->
              <form-field
                type="tel"
                [isOnlyNumber]="true"
                class="tw-w-full tw-px-1 tw-ml-[-59px]"
                [label]="'pages.sendSmsFromMap.fields.startFrom'|translate"
                [min]="1"
                [value]="hamrahAvalSendingInfo?.startFrom|numberSeparator"
                (valueChange)="sendFromIndexChanged($event,'hamrahAval')"
              >
              </form-field>

              <!--MCI send count-->
              <form-field
                type="tel"
                [isOnlyNumber]="true"
                class="tw-w-full tw-px-1 tw-ml-[-59px]"
                [label]="'pages.sendSmsFromMap.fields.count'|translate"
                [min]="1"
                [value]="hamrahAvalSendingInfo?.sendCount|numberSeparator"
                (valueChange)="sendCountChanged($event,'hamrahAval')"
              >
              </form-field>
              <mat-error *ngIf="isWrongHamrahAvalIndex">
                <div class="error-text">
                  <span
                    class="text-error-color tw-mx-6 tw-text-[11px] tw-font-medium"
                    >{{'messages.wrongIndex'|translate}}</span
                  >
                </div>
              </mat-error>
            </div>

            <!-- add -->
            <button
              *ngIf="EditableItem?.hamrahAvalInfo==null || EditableItem?.hamrahAvalInfo?.sendCount==0"
              type="button"
              class="btn tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              [themeColor]="'btn'"
              (click)="addOrUpdateHamrahAval(selectedLayer)"
              [disabled]="isDisabledHamrahAvalAddBtn"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.add" | translate }}</span>
              <i class="mdi mdi-plus-thick tw-text-white"></i>
            </button>
            <!-- edit -->
            <button
              *ngIf="EditableItem?.hamrahAvalInfo!=null && EditableItem?.hamrahAvalInfo.sendCount>0"
              type="button"
              class="btn tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              [themeColor]="'btn-info'"
              (click)="addOrUpdateHamrahAval(selectedLayer)"
              [disabled]="isDisabledHamrahAvalAddBtn"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.edit" | translate }}</span>
              <i class="mdi mdi-pencil tw-text-white"></i>
            </button>
            <!-- delete -->
            <button
              *ngIf="EditableItem?.hamrahAvalInfo!=null && EditableItem?.hamrahAvalInfo.sendCount>0"
              type="button"
              class="btn btn-danger tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              (click)="removeHamrahAval(selectedLayer)"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.delete" | translate }}</span>
              <i class="mdi mdi-delete"></i>
            </button>
          </fieldset>
        </section>
        <!--------------------------------------- irancell --------------------------------------->
        <section
          class="operator-section tw-mt-4"
          #irancellPanel
          *ngIf="selectedLayer!=null"
        >
          <fieldset>
            <legend>
              <span> {{'common.sendTo' | translate}}</span>
              <span class="mtn-color tw-mr-1">
                {{'common.mtn' | translate}}</span
              >
              <img
                src="/assets/media/svg/operator/mtn.svg"
                class="tw-mx-1"
                width="16"
              />
            </legend>
            <!--MTN total count-->
            <form-field
              class="tw-w-full tw-px-1 tw-ml-[-59px] tw-block"
              [label]="'pages.sendSmsFromMap.fields.total'|translate"
              [value]="selectedLayerTotalIrancell|numberSeparator"
              [isReadOnly]="true"
            >
            </form-field>
            <div class="tw-flex flex-wrap">
              <!--MTN start from-->
              <form-field
                type="tel"
                [isOnlyNumber]="true"
                class="tw-w-full tw-px-1 tw-ml-[-59px]"
                [label]="'pages.sendSmsFromMap.fields.startFrom'|translate"
                [min]="1"
                [value]="irancellSendingInfo?.startFrom|numberSeparator"
                (valueChange)="sendFromIndexChanged($event,'irancell')"
              >
              </form-field>

              <!--MTN send count-->
              <form-field
                type="tel"
                [isOnlyNumber]="true"
                class="tw-w-full tw-px-1 tw-ml-[-59px]"
                [label]="'pages.sendSmsFromMap.fields.count'|translate"
                [min]="1"
                [value]="irancellSendingInfo?.sendCount|numberSeparator"
                (valueChange)="sendCountChanged($event,'irancell')"
              >
              </form-field>
              <mat-error *ngIf="isWrongIrancellIndex">
                <div class="error-text">
                  <span
                    class="text-error-color tw-mx-6 tw-text-[11px] tw-font-medium"
                    >{{'messages.wrongIndex'|translate}}</span
                  >
                </div>
              </mat-error>
            </div>

            <!-- add -->
            <button
              *ngIf="EditableItem?.irancellInfo==null || EditableItem?.irancellInfo?.sendCount==0"
              type="button"
              class="btn tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              [themeColor]="'btn'"
              (click)="addOrUpdateIrancell(selectedLayer)"
              [disabled]="isDisabledIrancellAddBtn"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.add" | translate }}</span>
              <i class="mdi mdi-plus-thick tw-text-white"></i>
            </button>
            <!-- edit -->
            <button
              *ngIf="EditableItem?.irancellInfo!=null && EditableItem?.irancellInfo.sendCount>0"
              type="button"
              class="btn tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              [themeColor]="'btn-info'"
              (click)="addOrUpdateIrancell(selectedLayer)"
              [disabled]="isDisabledIrancellAddBtn"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.edit" | translate }}</span>
              <i class="mdi mdi-pencil tw-text-white"></i>
            </button>
            <!-- delete -->
            <button
              *ngIf="EditableItem?.irancellInfo!=null && EditableItem?.irancellInfo.sendCount>0"
              type="button"
              class="btn btn-danger tw-my-1 button-shadow tw-w-full tw-flex-center tw-font-medium"
              (click)="removeIrancell(selectedLayer)"
              mat-ripple
            >
              <span class="tw-mx-1">{{ "common.delete" | translate }}</span>
              <i class="mdi mdi-delete"></i>
            </button>
          </fieldset>
        </section>
      </mat-expansion-panel>
      <!-- end of hamrah aval region setting-->
      <!-- #endregion -->

      <!-- #region detail's-->
      <!-- start of detail of region's-->
      <mat-expansion-panel
        class="detail-exapnsion-panel"
        *ngIf="Items!=null && Items.length>0"
      >
        <mat-expansion-panel-header class="expansion-panel-header">
          <mat-panel-title class="text-info tw-font-medium">
            <i class="mdi mdi-bookmark-check text-info mdi-24px tw-ml-1"></i>
            {{'pages.sendSmsFromMap.fields.detailOfSendingRegions' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div
          class="detail-row tw-border-2 tw-border-dark-400 dark:tw-border-primary-700"
          *ngFor="let item of Items"
          (click)="moveToSendingInfo(item)"
        >
          <div class="cityName tw-bg-dark-400 dark:tw-bg-primary-700">
            {{item.cityName}}
            <span class="postalCode">{{item.postalCode}}</span>
          </div>
          <div class="operator-container">
            <img
              [src]="mciImage"
              class="img img-fluid"
              alt="{{'pages.sendSmsFromMap.fields.hamrahAval' | translate}}"
            />
            <span>
              {{'pages.sendSmsFromMap.fields.simpleCount' | translate}} :
              <span class="tw-font-bold" *ngIf="item.hamrahAvalInfo!=null">
                {{item.hamrahAvalInfo.sendCount| numberSeparator }}
              </span>
              <span class="tw-font-bold" *ngIf="item.hamrahAvalInfo==null">
                0
              </span>
            </span>
          </div>
          <div class="operator-container">
            <img
              src="/assets/media/svg/operator/mtn.svg"
              class="img img-fluid"
              alt="{{'pages.sendSmsFromMap.fields.Irancell' | translate}}"
            />
            <span>
              {{'pages.sendSmsFromMap.fields.simpleCount' | translate}} :
              <span class="tw-font-bold" *ngIf="item.irancellInfo!=null">
                {{item.irancellInfo.sendCount| numberSeparator }}
              </span>
              <span class="tw-font-bold" *ngIf="item.irancellInfo==null">
                0
              </span>
            </span>
          </div>
        </div>
      </mat-expansion-panel>
      <!-- #endregion -->
      <!-- #region start of total info-->
      <ng-container #totalTemplate>
        <mat-expansion-panel
          class="nextStep-exapnsion-panel"
          *ngIf="totalSendCount.hamrahAval+totalSendCount.irancell > 0"
        >
          <mat-expansion-panel-header class="expansion-panel-header">
            <mat-panel-title class="tw-font-semibold">
              {{'pages.sendSmsFromMap.fields.acceptAndNext' | translate}}
              <i
                class="mdi mdi-arrow-left-thick text-dark mdi-24px tw-mx-2"
              ></i>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div
            class="detail-row tw-border-2 tw-border-dark-400 dark:tw-border-primary-700"
          >
            <div class="cityName tw-bg-dark-400 dark:tw-bg-primary-700">
              {{'pages.sendSmsFromMap.fields.totalSendCount' | translate}}
            </div>
            <div class="operator-container">
              <img
                [src]="mciImage"
                class="img img-fluid"
                alt="{{'pages.sendSmsFromMap.fields.hamrahAval' | translate}}"
              />
              <span>
                {{'pages.sendSmsFromMap.fields.simpleCount' | translate}}:
                <span class="tw-font-bold">
                  {{totalSendCount.hamrahAval| numberSeparator }}
                </span>
              </span>
            </div>
            <div class="operator-container">
              <img
                src="/assets/media/svg/operator/mtn.svg"
                class="img img-fluid"
                alt="{{'pages.sendSmsFromMap.fields.Irancell' | translate}}"
              />
              <span>
                {{'pages.sendSmsFromMap.fields.simpleCount' | translate}}:
                <span class="tw-font-bold">
                  {{totalSendCount.irancell| numberSeparator }}
                </span>
              </span>
            </div>
          </div>

          <button
            class="btn tw-my-3 button-shadow tw-w-full tw-flex-center tw-font-medium"
            [themeColor]="'btn'"
            (click)="confirmAndNextStep()"
            mat-ripple
          >
            {{"common.nextStep"|translate}}
            <i
              class="mdi mdi-arrow-left-thick mdi-18px tw-mx-2 tw-text-white"
            ></i>
          </button>
        </mat-expansion-panel>
      </ng-container>
      <!-- #endregion-->
    </mat-accordion>
    <!-- #endregion -->
  </div>
  <!-- container panel -->
  <div class="container-panel md:tw-w-full tw-p-4">
    <!-- #region map area-->
    <mgl-map
      [style]="styleUrl"
      [zoom]="[Zoom]"
      [center]="center"
      [transformRequest]="transformReq"
      class="map"
      (load)="onMapReady($event)"
      [cursorStyle]="cursorStyle"
    >
      <mgl-control>
        <div class="mapboxgl-ctrl-group">
          <button
            class=""
            type="button"
            title="{{ 'common.openSelector' | translate}}"
            aria-label="openSelector"
            aria-disabled="false"
            (click)="toggleContainer()"
          >
            <i
              class="arrow-icon mdi mdi-arrow-left"
              *ngIf="!containerOpened"
            ></i>
            <i
              class="arrow-icon mdi mdi-arrow-right"
              *ngIf="containerOpened"
            ></i>
          </button>
        </div>
      </mgl-control>
      <mgl-control mglNavigation></mgl-control>

      <!-- postal code area-->
      <mgl-geojson-source id="oneline" [data]="polygons"> </mgl-geojson-source>
      <mgl-layer
        id="postalCodes-lines"
        type="fill"
        source="oneline"
        [paint]="{
                  'fill-color': ColoringSettings.Color,
                  'fill-opacity' : ColoringSettings.Opacity
                }"
        (click)="onClick($event)"
        (layerMouseMove)="activateHoverOn($event)"
        (layerMouseLeave)="disableHover()"
      ></mgl-layer>
      <mgl-layer
        id="postal-fill"
        type="fill"
        source="oneline"
        [paint]="{
                  'fill-color': ColoringSettings.HoverColor,
                  'fill-opacity': ColoringSettings.HoverOpacity
                }"
        [filter]="hoverFilter"
      ></mgl-layer>

      <mgl-layer
        id="postal-in-query"
        type="fill"
        source="oneline"
        [paint]="{
                'fill-color': ColoringSettings.InQueryColor,
                'fill-opacity': ColoringSettings.InQueryOpacity
              }"
        [filter]="InQueryFilter"
      ></mgl-layer>
      <mgl-layer
        id="postal-selected"
        type="fill"
        source="oneline"
        [paint]="{
                  'fill-color': ColoringSettings.SelectedColor,
                  'fill-opacity': ColoringSettings.SelectedOpacity
                }"
        [filter]="selectedFilter"
      ></mgl-layer>
    </mgl-map>
    <!-- #endregion -->
  </div>
  <!-- wating panel-->
  <div class="wating-panel" *ngIf="loading">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
